import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "platmap" }
const _hoisted_2 = {
  key: 1,
  id: "plan-overlay"
}

import { Loader } from '@googlemaps/js-api-loader';
import { isMobile, isTablet, isIE } from 'mobile-device-detect';
import lodash from 'lodash';
import { GoogleMap, CustomMarker, InfoWindow } from 'vue3-google-map';
import PlatMapLotInfobox from './../components/modal/PlatMapInfoWindow.vue';
import PlatMapAminityInfobox from './../components/modal/PlatMapAmenityInfoWindow.vue';
import {
  getPlatMapModalPosition,
  getPlatMapModalPositionMobile,
  getCentroid,
  fitSVGToContainer,
  getPositiveValue,
  tranformOriginOfElement,
  getTransformMatrix,
  calculateUnderlayMobileLotPosition,
} from './../core';
import { apiFetchAminityInfo, apiFetchLotInfo } from './../api';
import { Status, Settings, UrlFilterList } from './../constant';
import {
  LotDetail,
  LotPosition,
  Amenity,
  LotInfo,
  Sibling,
  LotCount,
  NeighborhoodsLots,
  NeighborhoodInfo,
  LotCountNeighborhood,
  CommunityQmiDetails,
  AmenityInfo,
  SidebarHomePlan,
  NeighboorhoodCoords,
  QmiDetails,
  CommunityFutureHomePlans,
  ComparedSvgFooterData,
} from './../types';
import {
  computed,
  createApp,
  reactive,
  ref,
  watch,
  toRefs,
  onMounted,
  nextTick,
  inject,
  h,
  render,
  Component,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SoldPending from '@/assets/icons/SoldPending.vue'
import SoldContengency from '@/assets/icons/SoldContengency.vue';

const ns = 'http://www.w3.org/2000/svg';

export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapMain',
  props: {
    qmiDetails: {},
    homeplans: { default: () => [] },
    neighborhoods: { default: () => [] },
    selectedNeighborhoodIds: { default: () => [] },
    underlay: { type: Boolean },
    lots: { default: () => [] },
    amenities: { default: () => [] },
    svg: {},
    selectedHomePlanId: {},
    selectedJobNum: {},
    neighborhoodId: {},
    communityId: {},
    centerLat: {},
    centerLong: {},
    neighborhoodCenterLat: {},
    neighborhoodCenterLong: {},
    swCornerLong: {},
    swCornerLat: {},
    neCornerLong: {},
    neCornerLat: {},
    mapDefaultZoom: {},
    isKioskMode: { type: Boolean },
    listPlanId: { default: () => [] },
    futureHomePlans: {},
    levels: { default: () => [] },
    activeLevel: {},
    hoverNeighborZoomLevel: {},
    isDisableHoverNeighbor: { type: Boolean },
    centerMap: {}
  },
  emits: [
  'updateFooterData',
  'showPlanFutureLotFlyout',
  'updateNotOnlyReservedPlan',
  'setZoomLevelMapPage',
  'setAmenities',
  'cleanHomeId',
  'loadLotInfo',
  'loadAminityInfo',
  'closeLotInfo',
  'setselectQmiData',
  'closeAmenityInfo',
  'handleVisitClick',
  'calculateContactInfoTopPosition',
  'autoSelectLevel',
  'hideSibling',
  'updateLotInfo',
  'disableZoomIn',
  'disableZoomOut',
  'hideSidebar',
  'hideHeader',
  'hideFooter',
  'showHeader',
  'showFooter',
  'showSidebar',
  'calculateSoldLotsPercentage',
  'disableZoomOut',
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const mode = inject('mode', ref(''));

const loader = new Loader({
  apiKey: 'AIzaSyAFN6T9RwgQ8dEGKzI9QvvXxeC7Bj6z9ME',
  version: 'weekly',
  libraries: ['places'],
});

// Create a promise that resolves to the Google Maps API
const apiPromise = loader.load();

const router = useRouter();
const route = useRoute();
const props = __props;

const {
  qmiDetails,
  homeplans,
  neighborhoods,
  selectedNeighborhoodIds,
  underlay,
  lots,
  amenities,
  svg,
  selectedHomePlanId,
  selectedJobNum,
  neighborhoodId,
  communityId,
  centerLat,
  centerLong,
  neighborhoodCenterLat,
  neighborhoodCenterLong,
  swCornerLong,
  swCornerLat,
  neCornerLong,
  neCornerLat,
  mapDefaultZoom,
  isKioskMode,
  listPlanId,
  futureHomePlans,
  levels,
  activeLevel,
  hoverNeighborZoomLevel,
  isDisableHoverNeighbor,
  centerMap,
} = toRefs(props);

const overlay = ref<any>(null);
const mapRef = ref<any>(null);
const svgContainer = ref<any>(null);
const $elmnt = ref<HTMLElement | null>(null);

const $gmap = ref<any>(null);

const styleObject = reactive({
  height: `${window.innerHeight - 70}px`,
  width: `${window.innerWidth}px`,
});

const svgZoom = ref(isMobile ? Settings.MOBILE_DEFAULT_SVG_SCALE : 1);
const isDisabledZoomOut = ref(false);
const isDisabledZoomIn = ref(false);

const pos1 = ref(0);
const pos2 = ref(0);
const pos3 = ref(0);
const pos4 = ref(0);
const evCache = ref<PointerEvent[]>([]);
const prevDiff = ref(-1);
const idleListener = ref<any>(null);

const amenityId = ref<string>('');
const selectedLotId = ref<string>('');
const googleInfoWindow = ref<any>(null);
const googleAmenityInfoWindow = ref<any>(null);
const hasMobile = !!(isMobile && !isTablet);

const lotsCount = reactive<LotCount>({
  available: 0,
  model: 0,
  quickmovein: 0,
  sold: 0,
  reserved: 0,
});

const selectedCommunityLots = ref<LotDetail[]>([]);
const lastNeighborhoodVisited = ref<string>('');
const neighborhoodLotsCount = ref<LotCountNeighborhood[]>([]);
const selectedNeighborhoodLots = ref<LotDetail[]>([]);
const uniqueAmenity = ref<string[]>([]);
const amenityInfo = ref<AmenityInfo[]>([]);
const lotDetail = ref<Element[]>([]);
const notReservedPlan = ref<string[]>([]);
const selectQmiData = ref({} as QmiDetails);

const emit = __emit;

// injector
const showDivisionCommunityDropdown = inject(
  'setSelectionDropdown',
  ref(false)
);

const disablingHover = computed(() => {
  return isDisableHoverNeighbor.value + ' ' + hoverNeighborZoomLevel.value;
});

const callHiglightLots = computed(() => {
  return (
    selectedHomePlanId.value +
    ' ' +
    selectedJobNum.value +
    ' ' +
    selectedNeighborhoodIds.value.join(',')
  );
});
watch(activeLevel, (newValue: string, oldValue: string) => {
  if (newValue !== oldValue) {
    const containerElement = document.querySelector('#svgContainer') as
      | HTMLElement
      | undefined;

    let pathData: Element[] = [];

    if (underlay.value) {
      const neighborhoodIds: string[] = [];
      neighborhoods.value.forEach((neighborhood) => {
        neighborhoodIds.push(neighborhood.neighborhood_code);
      });
      pathData = getLots(neighborhoodIds, containerElement);
    } else {
      pathData = getLots(selectedNeighborhoodIds.value, containerElement);
    }

    // bind logic for each lot
    pathData.forEach((element: any) => {
      const lotId = element.attributes['id'].value;
      const lotDetail = lodash.find(selectedCommunityLots.value, {
        id: lotId,
      }) as LotDetail;

      const polygon: any = Array.from(element.children).filter(
        (child) => (child as any).tagName.toLowerCase() === 'polygon'
      )[0] as any;

      const path: any = polygon ? null : Array.from(element.children)[0];

      const isActive =
        lotDetail?.status !== Status.RESERVED &&
        (!activeLevel.value.trim() || lotDetail?.level === activeLevel.value);

      element.style.cursor = isActive ? 'pointer' : 'default';

      element.onclick = isActive
        ? (event: Event) =>
            handleLotClick(
              lotId,
              getHomPlanIds(lotDetail),
              lotDetail ? lotDetail.status : '',
              event
            )
        : null;

      const targetElement = polygon || path || element;
      bindActiveLeveltoLots(isActive, element, targetElement, path);
    });
  }
});

watch(selectedNeighborhoodIds, (newValue: string[], oldValue: string[]) => {
  if (newValue !== oldValue) {
    lotDetail.value = getLots(selectedNeighborhoodIds.value);
  }
  if (!newValue.length && oldValue.length) {
    showWholeCommunity();
  } else if (newValue.length && oldValue !== newValue) {
    $gmap.value.setZoom(mapDefaultZoom.value);
  }
  resetPlanClick();
});

watch(hoverNeighborZoomLevel, (newVal: number, oldVal: number) => {
  if (newVal !== oldVal && newVal !== 0) {
    setTimeout(() => {
      $gmap.value.setCenter({
        lat: +centerMap.value.latitude,
        lng: +centerMap.value.longitude,
      });
      $gmap.value.setZoom(newVal);
    }, 300);
  }
});

watch(isDisableHoverNeighbor, (newVal: boolean, oldVal: boolean) => {
  if (newVal && hoverNeighborZoomLevel.value === 0) {
    setCentreLatLong();
  }
});

watch(neighborhoodCenterLat, () => {
  showWholeCommunity();
  $gmap.value.setCenter({
    lat: +neighborhoodCenterLat.value,
    lng: +neighborhoodCenterLong.value,
  });
  setTimeout(() => {
    $gmap.value.setZoom(mapDefaultZoom.value);
  }, 200);
});

watch(disablingHover, () => {
  setTimeout(() => {
    if (isDisableHoverNeighbor.value) {
      setCentreLatLong();
    }
  }, 500);
});

watch(callHiglightLots, (val: string, oldVal: string) => {
  if (val !== oldVal) {
    highlightMatchedLots(selectedHomePlanId.value, selectedJobNum.value);
  }
});

watch(isDisabledZoomOut, () => {
  emit('disableZoomOut');
});

watch(isDisabledZoomIn, () => {
  emit('disableZoomIn');
});

watch(selectedNeighborhoodIds, () => {
  emit('hideSibling');
});
const setCentreLatLong = () => {
  showWholeCommunity(); // You need this function defined
  $gmap.value.setCenter({
    lat: +neighborhoodCenterLat.value,
    lng: +neighborhoodCenterLong.value,
  });
  setTimeout(() => {
    $gmap.value.setZoom(mapDefaultZoom.value);
  }, 200);
};

const bindActiveLeveltoLots = (
  isActive: boolean,
  element: HTMLElement,
  targetElement: any,
  path: any
) => {
  if (isActive) {
    if (element && element.classList.contains('lot-dim')) {
      element.classList.remove('lot-dim');
      targetElement.style.fill = scaleRgb(targetElement.style.fill, true);
    }
  } else {
    if (element && !element.classList.contains('lot-dim')) {
      element.classList.add('lot-dim');
      targetElement.style.fill =
        path != null
          ? scaleRgb(element.style.fill, false)
          : scaleRgb(targetElement.style.fill, false);
    }
  }
  bindElementTextColor(isActive, targetElement, element);
};

const bindElementTextColor = (
  isActive: boolean,
  targetElement: any,
  element: HTMLElement
) => {
  let numberElement: any = Array.from(
    targetElement.nearestViewportElement.children
  ).find((el: any) => el.tagName === 'g' && el.id === 'Numbers');

  let paths: any;
  if (numberElement) {
    paths = numberElement.querySelectorAll('g[class=""]')[0];
    if (!paths?.length) {
      numberElement = Array.from(element.children).find(
        (child: any) => child.tagName.toLowerCase() === 'g'
      );
      paths = numberElement ? numberElement.querySelectorAll('path') : [];
    }
  }

  numberElement = numberElement
    ? numberElement
    : Array.from(element.children).filter(
        (child: any) => child.tagName.toLowerCase() === 'path'
      );

  paths = paths?.length
    ? paths
    : numberElement.filter((p: any) => p.classList.contains('st46'));

  paths.forEach((path: any) => {
    path.style.fill = isActive ? '#fff' : '#000';
  });
};

const scaleRgb = (originalRgb: string, getOriginal: boolean) => {
  if (originalRgb) {
    const nums = originalRgb.match(/\d+/g)?.map(Number) || [];
    const scaled = getOriginal
      ? nums.map((c) => Math.min(Math.round(c / 0.6), 255))
      : nums.map((c) => Math.min(Math.floor(c * 0.6), 255));
    return `rgb(${scaled.join(',')})`;
  }
  return originalRgb;
};

const resetQmiClick = (pathData: Element[]) => {
  if (selectedJobNum.value) {
    const qmi = document.getElementById(selectedJobNum.value) as Element | null;
    if (qmi && !pathData.includes(qmi)) {
      emit('cleanHomeId');
    }
  }
};

const resetPlanClick = () => {
  const pathData = getLots(selectedNeighborhoodIds.value);
  let selectedPlanExistCurrentNeighbor = false;

  if (selectedHomePlanId.value) {
    pathData.forEach((element: any) => {
      const homeplans = element.getAttribute('data-homeplans');
      const lotStatus = element.getAttribute('data-status');

      if (homeplans && lotStatus && lotStatus !== Status.RESERVED) {
        const planIds = homeplans.split(',');
        const planFound = lodash.includes(planIds, selectedHomePlanId.value);

        if (planFound) {
          selectedPlanExistCurrentNeighbor = true;
          return;
        }
      }
    });

    if (!selectedPlanExistCurrentNeighbor) {
      emit('cleanHomeId');
    }
  }

  resetQmiClick(pathData);
};

const showWholeCommunity = () => {
  const bound = $gmap.value.getBounds();
  const cornerCoords = [
    { lat: swCornerLat.value, lng: swCornerLong.value },
    { lat: neCornerLat.value, lng: neCornerLong.value },
  ];

  cornerCoords.forEach((coord) => {
    bound.extend(coord);
  });

  const zoomLevel = setZoomLevel();
  $gmap.value.setCenter({ lat: centerLat.value, lng: centerLong.value });
  $gmap.value.setZoom(zoomLevel);
};

const setZoomLevel = () => {
  const map = document.getElementById('map') as HTMLDivElement;
  const mapWidth = map.offsetWidth;
  const mapHeight = map.offsetHeight;

  const bounds = $gmap.value
    .getBounds()
    .extend(
      { lat: swCornerLat.value, lng: swCornerLong.value },
      { lat: neCornerLat.value, lng: neCornerLong.value }
    );

  const worldCoordinateWidth = Math.abs(
    neCornerLong.value - swCornerLong.value
  );
  const worldCoordinateHeight = Math.abs(neCornerLat.value - swCornerLat.value);

  const zoomWidth = Math.floor(Math.log2(mapWidth / worldCoordinateWidth));
  const zoomHeight = Math.floor(Math.log2(mapHeight / worldCoordinateHeight));

  return Math.min(zoomWidth, zoomHeight);
};

const mountVueOverlay = () => {
  const svgContainer = mapSvgContainer();

  function VueOverlay(bounds, options) {
    this.$el = svgContainer;
    this.$bounds = bounds;
    this.$centered = options.centered;
  }

  VueOverlay.prototype = Object.create(
    window.google.maps.OverlayView.prototype
  );
  VueOverlay.prototype.constructor = VueOverlay;

  VueOverlay.prototype.onAdd = function () {
    this.$el.style.position = 'absolute';
    const panes = this.getPanes();
    panes.overlayMouseTarget.appendChild(this.$el);
  };

  VueOverlay.prototype.onRemove = function () {
    this.$el.parentNode.removeChild(this.$el);
  };

  VueOverlay.prototype.draw = function () {
    const overlayProjection = this.getProjection();
    const sw = overlayProjection.fromLatLngToDivPixel(
      this.$bounds.getSouthWest()
    );
    const ne = overlayProjection.fromLatLngToDivPixel(
      this.$bounds.getNorthEast()
    );

    const div = this.$el;
    const svgElement = div.querySelectorAll('svg')[0];

    div.style.left = `${sw.x}px`;
    div.style.top = `${ne.y}px`;
    div.style.width = `${ne.x - sw.x}px`;
    div.style.height = `${sw.y - ne.y}px`;

    svgElement.style.left = `${sw.x}px`;
    svgElement.style.top = `${ne.y}px`;
    svgElement.style.width = `${ne.x - sw.x}px`;
    svgElement.style.height = `${sw.y - ne.y}px`;
  };

  return VueOverlay;
};

const ready = ref(false);

onMounted(() => {
  if (!underlay.value) {
    platmapOverlay(false);
    compareFooterDataLotData();
  } else {
    selectQmi();

    nextTick(async () => {
      await apiPromise;
      const VueOverlay = mountVueOverlay();

      const mapElement = document.getElementById('map') as HTMLElement;
      $gmap.value = new (window as any).google.maps.Map(mapElement, {
        zoom: mapDefaultZoom.value,
        minZoom: Settings.MAP_MIN_SVG_SCALE,
        maxZoom: Settings.MAP_MAX_SVG_SCALE,
        center: { lat: centerLat.value, lng: centerLong.value },
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        gestureHandling: "greedy",
        scrollwheel: true,
        clickableIcons: false,
      });

      const bounds = new (window as any).google.maps.LatLngBounds(
        new (window as any).google.maps.LatLng(
          swCornerLat.value,
          swCornerLong.value
        ),
        new (window as any).google.maps.LatLng(
          neCornerLat.value,
          neCornerLong.value
        )
      );

      (window as any).google.maps.event.addListener(
        $gmap.value,
        'dragend',
        handleGoogleDragEnd
      );
      (window as any).google.maps.event.addListener(
        $gmap.value,
        'zoom_changed',
        handleGoogleMapZoom
      );

      overlay.value = new VueOverlay(bounds, {
        centered: true,
        layer: 'overlayLayer',
      });

      idleListener.value = (window as any).google.maps.event.addListener(
        $gmap.value,
        'idle',
        googleMapIdle
      );

      overlay.value.setMap($gmap.value);

      $gmap.value.setCenter({
        lat: neighborhoodCenterLat.value,
        lng: neighborhoodCenterLong.value,
      });
    });
  }
});

const selectQmi = () => {
  let qmiAddress = route.query[UrlFilterList.LOT] as string;

  if (qmiAddress && qmiAddress.length) {
    const address = qmiAddress.split('-');
    qmiAddress = address.join(' ').toLowerCase();

    // Search across every neighborhood's QMIs by address. A deep-linked QMI
    // can belong to a sibling neighborhood while a different (e.g. sold-out)
    // neighborhood is selected, and that neighborhood may have no entry in
    // qmiDetails — restricting the search to it would miss the match (and
    // throw on the undefined array).
    const allQmi: QmiDetails[] = [];
    Object.values(qmiDetails.value).forEach((qmi: QmiDetails[]) =>
      allQmi.push(...qmi)
    );

    const data = allQmi.find((qmi) => {
      const eachQmiAddress = qmi.address.split(' ');
      return eachQmiAddress.join(' ').toLowerCase() === qmiAddress;
    });

    if (data) {
      selectQmiData.value = data;
    }

    emit('setselectQmiData', selectQmiData.value);
  }
};

const googleMapIdle = () => {
  setTimeout(() => {
    compareFooterDataLotData();
    emit('hideSibling');

    if (
      !selectedNeighborhoodIds.value.length &&
      !selectQmiData.value.neighborhood_code
    ) {
      showWholeCommunity();
    }

    if (selectQmiData.value.neighborhood_code) {
      selectedQmiClickEvent(selectQmiData.value.job_number);
      selectQmiData.value = {} as QmiDetails;
      emit('setselectQmiData', selectQmiData.value);
    }
  }, 500);

  (window as any).google.maps.event.removeListener(idleListener.value);
};

const underLayZoomIn = (zoomStep: number) => {
  const { zoom } = $gmap.value;
  let newZoom = zoom + zoomStep;

  if (newZoom >= Settings.MAP_MAX_SVG_SCALE) {
    isDisabledZoomIn.value = true;
    newZoom = Settings.MAP_MAX_SVG_SCALE;
  } else {
    isDisabledZoomIn.value = false;
  }

  if (newZoom <= Settings.MAP_MIN_SVG_SCALE) {
    isDisabledZoomOut.value = true;
    newZoom = Settings.MAP_MIN_SVG_SCALE;
  } else {
    isDisabledZoomOut.value = false;
  }

  $gmap.value.setZoom(newZoom);
};

const normalZoomIn = (zoomStep: number) => {
  emit('closeLotInfo');
  emit('closeAmenityInfo');

  let newSvgZoom = svgZoom.value + zoomStep;
  const mapMaxValue = isMobile
    ? Settings.MOBILE_MAX_SVG_SCALE
    : Settings.WEB_MAX_SVG_SCALE;
  const mapMinValue = isMobile
    ? Settings.MOBILE_MIN_SVG_SCALE
    : Settings.WEB_MIN_SVG_SCALE;

  if (newSvgZoom >= mapMaxValue) {
    isDisabledZoomIn.value = true;
    newSvgZoom = mapMaxValue;
  } else {
    isDisabledZoomIn.value = false;
  }

  if (newSvgZoom <= mapMinValue && newSvgZoom <= 0) {
    isDisabledZoomOut.value = true;
    newSvgZoom = mapMinValue;
  } else {
    isDisabledZoomOut.value = false;
  }

  svgZoom.value = newSvgZoom;

  const overlayContainer = document.getElementById('plan-svg') as HTMLElement;
  tranformOriginOfElement(overlayContainer, svgZoom.value, svgZoom.value);
};

const svgZoomIn = (zoomStep = 1) => {
  if (underlay.value) {
    underLayZoomIn(zoomStep);
  } else {
    normalZoomIn(zoomStep);
  }
};
const svgZoomOut = (zoomStep = 1) => {
  svgZoomIn(zoomStep * -1);
};

const svgAutoFit = () => {
  if (underlay.value) {
    $gmap.value.setZoom(mapDefaultZoom.value);
    $gmap.value.setCenter({ lat: centerLat.value, lng: centerLong.value });
  } else {
    svgZoom.value = 1;
    setTimeout(() => {
      platmapOverlay(true);
    }, 100);
  }
  isDisabledZoomOut.value = false;
  isDisabledZoomIn.value = false;
};

watch(svgContainer, () => {
  if (svgContainer.value) {
    ready.value = true;
  }
});

const mapSvgContainer = () => {
  const div = document.createElement('div');
  div.style.border = 'none';
  div.style.borderWidth = '0px';
  div.style.position = 'absolute';

  const localSvgContainer = document.createElement('div');
  localSvgContainer.id = 'svgContainer';
  localSvgContainer.innerHTML = svg.value;
  localSvgContainer.style.width = '100%';
  localSvgContainer.style.height = '100%';
  localSvgContainer.style.position = 'absolute';

  const neighborhoodIds: string[] = [];
  neighborhoods.value.forEach((neighborhood) => {
    neighborhoodIds.push(neighborhood.neighborhood_code);
  });

  const pathData = getLots(neighborhoodIds, localSvgContainer);
  lotDetail.value = getLots(selectedNeighborhoodIds.value, localSvgContainer);

  bindLotEvents(pathData);

  const amenities = getAmenities(communityId.value, localSvgContainer);
  bindAmenityEvents(amenities);

  removeSVGLegend(localSvgContainer);

  div.appendChild(localSvgContainer);
  svgContainer.value = localSvgContainer;

  return div;
};

const touchWheelEvents = (overlayContainer: HTMLElement) => {
  if ('ontouchstart' in window) {
    initPinchInPinchOut(overlayContainer);
  } else {
    const mouseWheelHandler = (e: WheelEvent) => {
      scrollCallback(e);
    };

    overlayContainer.addEventListener('wheel', mouseWheelHandler, {
      passive: false,
    });

    overlayContainer.addEventListener(
      'DOMMouseScroll',
      mouseWheelHandler as any,
      {
        passive: false,
      }
    );
  }
};

const platmapOverlay = (isFitCall: boolean) => {
  const overlayContainer = document.getElementById('plan-svg') as HTMLElement;
  overlayContainer.id = 'svgContainer';
  overlayContainer.innerHTML = svg.value;
  overlayContainer.style.position = 'absolute';

  emit('hideSibling');

  fitSVGToContainer(overlayContainer);

  if (isMobile) {
    overlayContainer.ontouchstart = dragMouseDown;
  } else {
    overlayContainer.onmousedown = dragMouseDown;
  }

  touchWheelEvents(overlayContainer);

  const pathData = getLots(selectedNeighborhoodIds.value, overlayContainer);
  lotDetail.value = pathData;

  const amenities = getAmenities(communityId.value, overlayContainer);

  bindLotEvents(pathData);
  bindAmenityEvents(amenities);
  removeSVGLegend(overlayContainer);

  $elmnt.value = overlayContainer;

  let rectangle = getCentroid(isFitCall);

  if (rectangle.scaleX > Settings.WEB_MAX_SVG_SCALE)
    rectangle.scaleX = Settings.WEB_DEFAULT_SVG_SCALE;
  if (rectangle.scaleY > Settings.WEB_MAX_SVG_SCALE)
    rectangle.scaleY = Settings.WEB_DEFAULT_SVG_SCALE;

  let width = overlayContainer.style.width;
  width = width.substring(0, width.length - 2);
  overlayContainer.style.transform = 'scale(1,1)';
  svgZoom.value = 1;

  setTimeout(() => {
    rectangle = getCentroid(isFitCall);
    overlayContainer.style.left = (isMobile ? 0 : +width / 2 + '') + 'px';
  }, 100);
};

const scrollCallback = (e: WheelEvent) => {
  e.preventDefault();
  const delta =
    (e.deltaY || -(e as any).wheelDelta || (e as any).detail) >> 10 || 1;
  svgZoomIn((e as any).wheelDelta > 0 ? 0.5 : -0.5);
};

const getSelectedNeighborhoodLots = () => {
  let selectedNeighborhoodLots: LotDetail[] = [];
  if (selectedNeighborhoodIds.value.length) {
    lots.value.forEach((neighborhood) => {
      if (neighborhood.neighborhood_code === selectedNeighborhoodIds.value[0]) {
        selectedNeighborhoodLots = neighborhood.lots;
      }
    });
  }
  return selectedNeighborhoodLots;
};

const calculateNeighborhoodLotsCount = (neighborhood: NeighborhoodsLots) => {
  const lotsCount: LotCountNeighborhood = {
    neighborhoodId: neighborhood.neighborhood_code,
    available: 0,
    model: 0,
    quickmovein: 0,
    sold: 0,
    reserved: 0,
    future: 0,
    soldpending: 0,
    soldclosed: 0,
    soldcontingency: 0,
    qmi: 0,
    reservedlothold: 0,
  };

  neighborhood.lots.forEach((lot) => {
    let status = lot.status || '';
    status = status.toLowerCase().replace(/\s+/g, '').replace(/-/g, '');
    if (lot.isFuturePlan || status === 'futurehome') {
      lotsCount.future += 1;
      return;
    }
    if (status in lotsCount) {
      (lotsCount as any)[status] += 1;
    }
  });

  const existingIndex = neighborhoodLotsCount.value.findIndex(
    (n) => n.neighborhoodId === lotsCount.neighborhoodId
  );

  if (existingIndex !== -1) {
    neighborhoodLotsCount.value[existingIndex] = lotsCount;
  } else {
    neighborhoodLotsCount.value.push(lotsCount);
  }
};

const getAllCommunityLots = () => {
  let allCommunityLots: LotDetail[] = [];
  if (neighborhoods.value.length) {
    lots.value.forEach((neighborhood) => {
      allCommunityLots.push(...neighborhood.lots);
      calculateNeighborhoodLotsCount(neighborhood);
    });
  }
  return allCommunityLots;
};

const removeOnlyReservedLotPlan = (lots: LotDetail[]) => {
  lots.forEach((lot) => {
    if (lot.status !== Status.RESERVED) {
      lot.home_planes.forEach((element) => {
        const updatePlan = homeplans.value.find(
          (plan) => plan.plan_id === element
        );
        if (updatePlan) notReservedPlan.value?.push(updatePlan.plan_id);
      });
    }
  });
  emit('updateNotOnlyReservedPlan', notReservedPlan.value);
};

const selectedQmiClickEvent = (lotId: string) => {
  const lotDetail = lodash.find(selectedCommunityLots.value, {
    id: lotId,
  }) as LotDetail;
  const element = document.getElementById(lotId);
  if (lotDetail && element) {
    const rect = element.getBoundingClientRect();
    const x = rect.left + window.scrollX + rect.width / 2;
    const y = rect.top + window.scrollY + rect.height / 2;
    const clickEvent = new MouseEvent('click', {
      bubbles: false,
      cancelable: true,
      view: window,
      clientX: x,
      clientY: y,
    });
    element.dispatchEvent(clickEvent);
  }
};

const removePlanFutureLot = (lotDetail: LotDetail, lotId: string) => {
  Object.values(futureHomePlans.value).forEach((plans) => {
    const data = plans.find((plan) => plan.job_number === lotId);
    if (data) {
      lotDetail.home_planes = [data.plan_id];
    }
  });
};

const hideSvgHomeIcon = (element: any) => {
  if (element.children[1] && element.children[1].attributes['id']) {
    const homeId = element.children[1].attributes['id'].value;
    element.children[1].style.display = homeId ? 'none' : 'flex';
  }
};

const fillLotColor = (pathTag: any, color: string) => {
  if (pathTag.tagName === 'g') {
    pathTag.children[0].style.fill = color;
  } else {
    pathTag.style.fill = color;
  }
};

const compareFooterDataLotData = () => {
  const neighborhoodStatus: ComparedSvgFooterData[] = [];
  lots.value.forEach((neighbor) => {
    const status = new Set<string>();
    neighbor.lots.forEach((lot) => {
      const lotPresentInSvg = document.getElementById(lot.id);
      if (lotPresentInSvg)
        status.add(
          lotPresentInSvg.getAttribute('data-status')?.toLowerCase() || ''
        );
    });
    neighborhoodStatus.push({
      neighborhood_code: neighbor.neighborhood_code,
      status: Array.from(status),
    });
  });
  emit('updateFooterData', neighborhoodStatus);
};

const bindLotEvents = async (pathData: Element[]) => {
  selectedCommunityLots.value = getAllCommunityLots();
  removeOnlyReservedLotPlan(selectedCommunityLots.value);

  pathData.forEach((element: any) => {
    const lotId = element.attributes['id'].value;
    const lotDetail = lodash.find(selectedCommunityLots.value, {
      id: lotId,
    }) as LotDetail;

    if (lotDetail) {
      emit('updateLotInfo', { lotInfo: lotDetail, lotId: lotDetail.id });
      element.style.fill = lotDetail.color;
      removePlanFutureLot(lotDetail, lotId);

      element.setAttribute('data-homeplans', lotDetail.home_planes);
      element.setAttribute('data-status', lotDetail.status);

      const circleTag = element.getElementsByTagName('circle');
      let color = lotDetail.color;

      if (circleTag.length > 0) {
        circleTag[0].style.fill = color;
      } else {
        const pathTag = element.children[0];
        if (pathTag) {
          fillLotColor(pathTag, color);
          hideSvgHomeIcon(element);
        }
      }
      if (lotDetail.status === Status.SOLD_PENDING) {
        const content = bindLazyIcons(SoldPending)
        element.innerHTML += content;
        const pathTag = element.children[0];
        if (pathTag) {
          fillLotColor(pathTag, 'url(#diagonalDots)');
        }
      }
      if (lotDetail.status === Status.SOLD_CONTINGENCY) {
        const content = bindLazyIcons(SoldContengency)
        element.innerHTML += content;
        const pathTag = element.children[0];
        if (pathTag) {
          fillLotColor(pathTag, 'url(#diagonalStripes)');
        }
      }

      if (lotDetail.status !== Status.RESERVED) {
        element.style.cursor = 'pointer';
        element.onclick = (event) =>
          handleLotClick(
            lotId,
            getHomPlanIds(lotDetail),
            lotDetail ? lotDetail.status : '',
            event
          );
      }
    } else {
      hideSvgHomeIcon(element.children[0]);
      if (element.children.length) {
        if (element.children[0].children.length) {
          element.children[0].children[0].style.fill = '#EEE6D0';
        }
      } else {
        element.children[0].style.fill = '#EEE6D0';
      }
    }
  });

  emit('calculateSoldLotsPercentage', neighborhoodLotsCount.value);
};

const getHomPlanIds = (lotDetail: LotDetail): string[] => {
  if (!lotDetail) return [];

  if (showDivisionCommunityDropdown.value) {
    return lotDetail.home_planes ?? [];
  }

  const validStatuses = [Status.AVAILABLE, Status.QUICK_MOVE_IN];
  return validStatuses.includes(lotDetail.status)
    ? lotDetail.home_planes ?? []
    : [];
};

const bindLazyIcons = (iconElement: Component) => {
  const container = document.createElement('div');
  const vnode = h(iconElement);
  render(vnode, container);
  return container.innerHTML;
}

const bindAmenityEvents = (amenityList: NodeListOf<Element>) => {
  let amenityArr: string[] = [];

  amenityList.forEach((element: any) => {
    const amenityId = element.attributes['id'].value;
    const amenityDetail = lodash.find(amenities.value, {
      id: amenityId,
    }) as any;

    
    if (amenityDetail) {
      element.style.cursor = 'pointer';
      amenityArr.push(amenityId);
      element.onclick = (event) => {
        handleAminityClick(amenityId, event);
      };
    }
  });

  uniqueAmenity.value = lodash.uniq(amenityArr);
  emit('setAmenities', uniqueAmenity.value);
};

const removeSVGLegend = (container: HTMLElement) => {
  const legends = container.querySelectorAll(`*[id^="Legend_"]`);
  legends.forEach((element: any) => {
    if (isIE) {
      element.parentNode?.removeChild(element);
    } else {
      element.remove();
    }
  });
};

const addClipPath = (
  pathTag: SVGPathElement | SVGPolygonElement,
  color: string,
  count: number,
  lotId: string
) => {
  const clipPath = document.createElementNS(
    ns,
    'clipPath'
  ) as SVGClipPathElement;
  clipPath.id = `${lotId}-${count}`;

  const d = pathTag.getAttribute('d');
  if (d) {
    // create path
    const path = document.createElementNS(ns, 'path') as SVGPathElement;
    path.setAttribute('d', d);
    path.setAttribute('fill', color);
    path.style.strokeWidth = '5';
    path.style.stroke = 'white';
    clipPath.appendChild(path);
  } else {
    // create polygon
    const polygon = document.createElementNS(
      ns,
      'polygon'
    ) as SVGPolygonElement;
    const points = pathTag.getAttribute('points');
    if (points) polygon.setAttribute('points', points);
    clipPath.appendChild(polygon);
  }

  return clipPath;
};

const removeClipPath = () => {
  const svg = document.getElementsByTagName('svg')[0];
  const defChildNode = document.getElementById('isp-custom-defs');
  if (defChildNode) {
    svg.removeChild(defChildNode);
  }
};

const updateSelectedQmi = (jobNum: string) => {
  // Search across every neighborhood's QMIs: a QMI lot can be clicked even
  // while a different (e.g. sold-out) neighborhood is selected, and that
  // neighborhood may have no entry in qmiDetails. job_number is unique
  // community-wide, so the flattened search always resolves the right QMI.
  const allQmi: QmiDetails[] = [];
  Object.values(qmiDetails.value).forEach((qmi) => allQmi.push(...qmi));
  const updatedQmiData = allQmi.find((qmi) => qmi.job_number === jobNum);

  if (updatedQmiData) {
    const newQuery = { ...route.query };
    const address = updatedQmiData.address.split(' ').join('-');
    newQuery[UrlFilterList.LOT] = [address];
    router.push({ query: newQuery }).catch(() => {});
  }
};

const isQMIOrFutureHome = (lotDetail: LotDetail) => {
  return (
    lotDetail.isFuturePlan ||
    lotDetail.status.toLowerCase() === 'future home' ||
    lotDetail.status.toLowerCase() === Status.QUICK_MOVE_IN.toLowerCase() ||
    lotDetail.status.toLowerCase() === 'qmi'
  );
};

const highlightQmiLot = (
  jobNum: string,
  defs: Element,
  count: number,
  pathData: Element[]
) => {
  const element: any = document.querySelectorAll(`*[id="${jobNum}"]`);
  const qmiLotExistSelectedNeighbor = document.getElementById(
    jobNum
  ) as Element;

  if (element.length && pathData.includes(qmiLotExistSelectedNeighbor)) {
    const lotDetail = lodash.find(selectedCommunityLots.value, {
      id: jobNum,
    }) as LotDetail;

    let pathTag = element[0].children[0];
    pathTag = resetElementCondoHome(pathTag);

    const color = pathTag.style.fill;
    const clipPath = addClipPath(pathTag, color, count, jobNum);
    if (clipPath) {
      defs.appendChild(clipPath);
    }

    element[0].children[1].style.display = 'flex';
    pathTag.style.stroke = 'white';
    pathTag.style.strokeWidth = '4';
    pathTag.style.vectorEffect = 'non-scaling-stroke';
    pathTag.setAttribute('clip-path', `url(#${jobNum}-${count})`);

    count++;

    if (lotDetail?.level && isQMIOrFutureHome(lotDetail)) {
      emit('autoSelectLevel', lotDetail?.level);
    } else {
      emit('autoSelectLevel', '');
    }
  } else {
    emit('autoSelectLevel', '');
  }
};

const getplanAttachedLotsStatus = (planId: string) => {
  const planAttachedLotsStatus = new Set<string>();

  const pathData = getLots(selectedNeighborhoodIds.value, svgContainer.value);

  pathData.forEach((element: any) => {
    if (element.attributes['data-homeplans']) {
      const homeplans = element.attributes['data-homeplans'].value;
      if (homeplans) {
        const planIds = homeplans.split(',');
        const planFound = lodash.includes(planIds, planId);
        if (planFound) {
          planAttachedLotsStatus.add(element.attributes['data-status'].value);
        }
      }
    }
  });

  return planAttachedLotsStatus;
};

const resetElementCondoHome = (pathTag: any) => {
  if (pathTag.tagName === 'g') {
    return pathTag.children[0];
  }
  return pathTag;
};

const applyBorder = (
  element: any,
  planFound: boolean,
  defs: Element,
  count: number,
  strokeWidth: string,
  stroke: string,
  strokeEffect: string,
  homeIconVisibility: string
) => {
  let pathTag = element.children[0];
  pathTag = resetElementCondoHome(pathTag);

  const lotId = element.attributes['id'].value;
  const color = pathTag.style.fill;

  if (planFound) {
    const lotDetail = lodash.find(selectedCommunityLots.value, {
      id: lotId,
    }) as LotDetail;

    // if (lotDetail.level && isQMIOrFutureHome(lotDetail)) {
    //   emit('autoSelectLevel',lotDetail.level);
    // }

    const clipPath = addClipPath(pathTag, color, count, lotId);
    if (clipPath) {
      defs.appendChild(clipPath);
    }

    stroke = 'white';
    strokeWidth = '5';
    pathTag.setAttribute('clip-path', `url(#${lotId}-${count})`);
    strokeEffect = 'non-scaling-stroke';
    count++;
    homeIconVisibility = 'flex';
  }

  if (element.children[1]?.attributes['id']?.value) {
    element.children[1].style.display = homeIconVisibility;
  }

  pathTag.style.stroke = stroke;
  pathTag.style.vectorEffect = strokeEffect;
  pathTag.style.strokeWidth = strokeWidth;
};

const deselectAllLots = () => {
  const pathData = getLots([]);
  pathData.forEach((element: any) => {
    if (element.attributes['data-homeplans']) {
      hideSvgHomeIcon(element);
      const pathTag = element.children[0];
      pathTag.style.stroke = '#111111';
      pathTag.style.vectorEffect = '';
      pathTag.style.strokeWidth = 'revert-layer';
    }
  });
};

const highlightMatchedLots = (selectedHomePlanId = '', jobNum = '') => {
  const pathData = getLots(selectedNeighborhoodIds.value);
  removeClipPath();
  deselectAllLots();

  const defs = document.createElementNS(ns, 'defs');
  defs.id = 'isp-custom-defs';

  let count = 0;
  pathData.forEach((element: any) => {
    if (element.attributes['data-homeplans']) {
      const homeplans = element.attributes['data-homeplans'].value;
      const lotStatus = element.attributes['data-status'].value;

      if (homeplans && lotStatus && lotStatus !== Status.RESERVED) {
        const planIds = homeplans.split(',');
        const planFound = lodash.includes(planIds, selectedHomePlanId);
        let strokeWidth = 'revert-layer';

        applyBorder(
          element,
          planFound,
          defs,
          count,
          strokeWidth,
          '#111111',
          '',
          'none'
        );
      }
    }
  });

  highlightQmiLot(jobNum, defs, count, pathData);

  const svg = document.getElementsByTagName('svg')[0];
  svg.appendChild(defs);
};

const toggleBars = () => {
  document.querySelector('.embtoolbox')?.classList.toggle('mobhide');
  document.querySelector('.mobile-legends')?.classList.toggle('mobhide');
  document.querySelector('.cp-filter')?.classList.toggle('mobhide');
  document.querySelector('.townhome-level')?.classList.toggle('mobhide');
};

const handleToggleBarsUnderlay = () => {
  if (hasMobile || (hasMobile && !underlay.value)) {
    toggleBars();
  }

  const isToolBoxHidden = document
    .querySelector('.embtoolbox')
    ?.classList.contains('mobhide');

  if (!underlay.value && hasMobile && !isToolBoxHidden) {
    toggleBars();
  }
};

const handleLotClick = (
  lotId: string,
  homeplanIds: string[],
  status: string,
  event: any
) => {
  emit('closeAmenityInfo');
  closeAmenityInfoWindow();

  const lotElement = document.getElementById(lotId) as HTMLElement;

  if (lotElement && status === Status.QUICK_MOVE_IN) {
    updateSelectedQmi(lotId);
  }

  if (underlay.value && (isMobile || isTablet)) {
    handleToggleBarsUnderlay();
    bindLotInfo(getLatLong(event.x, event.y), lotId);
    emit('cleanHomeId');
  } else {
    mobileHideHeader();
    const elementPosition = lotElement.getBoundingClientRect();
    const lotPosition = getPlatMapPosition(elementPosition);

    if (!underlay.value) {
      calculateUnderlayMobileLotPosition(
        lotPosition,
        elementPosition,
        svgZoom.value
      );
    }

    handleToggleBarsUnderlay();

    if (!event.bubbles && underlay.value) {
      $gmap.value.setCenter(getLatLong(event.x, event.y));
    }

    emit('loadLotInfo', { lotId, homeplanIds, lotPosition, status });
  }
};

const getPlatMapPosition = (elementPosition: DOMRect) => {
  if (underlay.value && (isMobile || isTablet)) {
    return getPlatMapModalPositionMobile(elementPosition);
  } else {
    const zoom = underlay.value ? $gmap.value.getZoom() : 0;
    return getPlatMapModalPosition(elementPosition, 0, zoom);
  }
};

const mobileHideHeader = () => {
  if (isMobile && underlay.value) {
    emit('hideHeader');
    emit('hideFooter');
  }
};

const getLatLong = (x: number, y: number) => {
  const latLngBounds = $gmap.value.getBounds();
  const neBound = latLngBounds.getNorthEast();
  const swBound = latLngBounds.getSouthWest();

  const neBoundInPx = $gmap.value.getProjection().fromLatLngToPoint(neBound);
  const swBoundInPx = $gmap.value.getProjection().fromLatLngToPoint(swBound);

  const procX = x / document.documentElement.scrollWidth;
  const procY = y / (document.getElementById('mainWrap')?.scrollHeight || 1);

  const newLngInPx = (neBoundInPx.x - swBoundInPx.x) * procX + swBoundInPx.x;
  const newLatInPx = (swBoundInPx.y - neBoundInPx.y) * procY + neBoundInPx.y;

  return $gmap.value
    .getProjection()
    .fromPointToLatLng(new window.google.maps.Point(newLngInPx, newLatInPx));
};

const setMapCenterUsingPixel = (x: number, y: number) => {
  $gmap.value.setCenter(getLatLong(x, y));
};

const handleAminityClick = (id: string, event: any) => {
  emit('closeLotInfo');
  closeMapInfoWindow();

  if (underlay.value) {
    if (hasMobile) {
      bindAminityInfo(getLatLong(event.x, event.y), id);
      toggleBars();
    } else {
      amenityId.value = id;
      setMapCenterUsingPixel(event.x, event.y);
      setTimeout(() => {
        loadAminityInfoWindow();
      }, 300);
    }
  } else {
    amenityId.value = id;
    loadAminityInfoWindow();
  }
};

const loadAminityInfoWindow = () => {
  const aminityElement = document.getElementById(
    amenityId.value
  ) as HTMLElement;
  const elementPosition = aminityElement.getBoundingClientRect();

  const lotPosition =
    isMobile || isTablet
      ? getPlatMapModalPositionMobile(elementPosition)
      : getPlatMapModalPosition(elementPosition, 0, 0);

  emit('loadAminityInfo', { amenityId: amenityId.value, lotPosition });
};

const dragMouseDown = (e: MouseEvent | TouchEvent) => {
  e = e || window.event;

  if (isMobile) {
    const touch =
      (e as TouchEvent).touches[0] || (e as TouchEvent).changedTouches[0];
    pos3.value = touch.clientX;
    pos4.value = touch.clientY;

    document.ontouchend = closeDragElement;
    document.ontouchmove = elementDrag;
  } else {
    const evt = e as MouseEvent;
    pos3.value = evt.clientX;
    pos4.value = evt.clientY;

    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  }
};

const elementDrag = (e: MouseEvent | TouchEvent) => {
  e = e || window.event;

  emit('closeLotInfo');
  emit('closeAmenityInfo');

  if (isMobile) {
    const touch =
      (e as TouchEvent).touches[0] || (e as TouchEvent).changedTouches[0];
    pos1.value = pos3.value - touch.clientX;
    pos2.value = pos4.value - touch.clientY;
    pos3.value = touch.clientX;
    pos4.value = touch.clientY;
  } else {
    const evt = e as MouseEvent;
    pos1.value = pos3.value - evt.clientX;
    pos2.value = pos4.value - evt.clientY;
    pos3.value = evt.clientX;
    pos4.value = evt.clientY;
  }

  const svgContainer = $elmnt.value || getSVGContainer();

  svgContainer.style.top = `${svgContainer.offsetTop - pos2.value}px`;
  svgContainer.style.left = `${svgContainer.offsetLeft - pos1.value}px`;
};

const closeDragElement = () => {
  if (isMobile) {
    document.ontouchend = null;
    document.ontouchmove = null;
  } else {
    document.onmouseup = null;
    document.onmousemove = null;
  }
};

const getSVGContainer = (): HTMLElement => {
  const platmapContainer = document.getElementById('platmap') as HTMLElement;
  const svgElement = platmapContainer.getElementsByTagName(
    'svg'
  )[0] as SVGSVGElement;
  return svgElement.parentNode as HTMLElement;
};

const getAmenities = (
  communityId: string,
  container?: HTMLElement
): NodeListOf<Element> => {
  return container
    ? container.querySelectorAll(`*[id^="${communityId}::"]`)
    : document.querySelectorAll(`*[id^="${communityId}::"]`);
};

const countLotsQmi = (
  filteredHomePlans: any[],
  differentNeighbourhoodListItems: Set<any>
) => {
  filteredHomePlans?.forEach((plan) => {
    if (plan.job_number) {
      const element: NodeListOf<HTMLElement> = svgContainer.value
        ? svgContainer.value.querySelectorAll(`*[id="${plan.job_number}"]`)
        : document.querySelectorAll(`*[id="${plan.job_number}"]`);

      const availabilityDetails = element.length
        ? element[0].getAttribute('data-status')
        : 'null';
      if (element.length && isLotCounted(availabilityDetails)) {
        differentNeighbourhoodListItems.add(element[0]);
      }
    }
  });
};

// An opportunity is any lot a buyer can still act on. Home type is deliberately
// not part of this test — condo / townhome / TC count exactly like single family
// (DREESSP-1151).
const isLotCounted = (availabilityDetails: string | null) => {
  return (
    availabilityDetails === Status.AVAILABLE ||
    availabilityDetails === Status.QUICK_MOVE_IN ||
    availabilityDetails === Status.QMI ||
    availabilityDetails === Status.FUTURE_HOME
  );
};

const countLotsFilterPlans = (filteredHomePlans: any[]) => {
  const differentNeighbourhoodListItems = new Set<Element>();

  lotDetail.value.forEach((element: any) => {
    const homeplans = element.attributes['data-homeplans']?.value;
    const availabilityDetails = element.attributes['data-status']?.value;

    if (homeplans && isLotCounted(availabilityDetails)) {
      const planIds = homeplans.split(',');
      const matchesFilteredPlan = filteredHomePlans?.some((plan) =>
        lodash.includes(planIds, plan.plan_id)
      );

      if (matchesFilteredPlan) {
        differentNeighbourhoodListItems.add(element);
      }
    }
  });

  countLotsQmi(filteredHomePlans, differentNeighbourhoodListItems);

  return differentNeighbourhoodListItems.size;
};

const getLots = (nbs: string[], container?: HTMLElement): Element[] => {
  let nodeList: Element[] = [];

  if (nbs.length) {
    nbs.forEach((neighborhood) => {
      const neighborhoodLots = container
        ? container.querySelectorAll(`*[id^="${neighborhood}-"]`)
        : document.querySelectorAll(`*[id^="${neighborhood}-"]`);
      nodeList = nodeList.concat(Array.from(neighborhoodLots));
    });
  } else {
    neighborhoods.value.forEach((neighborhood) => {
      const neighborhoodLots = container
        ? container.querySelectorAll(
            `*[id^="${neighborhood.neighborhood_code}-"]`
          )
        : document.querySelectorAll(
            `*[id^="${neighborhood.neighborhood_code}-"]`
          );
      nodeList = nodeList.concat(Array.from(neighborhoodLots));
    });
  }

  return nodeList;
};

const initPinchInPinchOut = (el: HTMLElement) => {
  el.onpointerdown = pointerdown_handler;
  el.onpointermove = pointermove_handler;
  el.onpointerup = pointerup_handler;
  el.onpointercancel = pointerup_handler;
  el.onpointerout = pointerup_handler;
  el.onpointerleave = pointerup_handler;
};

const pointerdown_handler = (ev: PointerEvent) => {
  evCache.value.push(ev);
};

const pointermove_handler = (ev: PointerEvent) => {
  for (let i = 0; i < evCache.value.length; i++) {
    if (ev.pointerId === evCache.value[i].pointerId) {
      evCache.value[i] = ev;
      break;
    }
  }
  if (evCache.value.length === 2) {
    const curDiff = Math.abs(
      evCache.value[0].clientX - evCache.value[1].clientX
    );
    callZoom(curDiff);
    prevDiff.value = curDiff;
  } else {
    prevDiff.value = -1;
  }
};

const callZoom = (curDiff: number) => {
  if (prevDiff.value > 0) {
    if (curDiff > prevDiff.value) {
      svgZoomIn(0.02); // make sure svgZoomIn is arrow or accessible here
    }
    if (curDiff < prevDiff.value) {
      svgZoomOut(0.02); // make sure svgZoomOut is arrow or accessible here
    }
  }
};

const remove_event = (ev: PointerEvent) => {
  evCache.value = evCache.value.filter((e) => e.pointerId !== ev.pointerId);
};

const pointerup_handler = (ev: PointerEvent) => {
  remove_event(ev);
  if (evCache.value.length < 2) {
    prevDiff.value = -1;
  }
};

const handleGoogleMapZoom = () => {
  emit('closeLotInfo');
  emit('closeAmenityInfo');
  const zoom = $gmap.value.getZoom();
  emit('setZoomLevelMapPage', zoom);

  if (zoom === Settings.MAP_MAX_SVG_SCALE) {
    isDisabledZoomIn.value = true;
  } else if (zoom === Settings.MAP_MIN_SVG_SCALE) {
    isDisabledZoomOut.value = true;
  } else {
    isDisabledZoomIn.value =
      $gmap.value.getZoom() >= Settings.MAP_MAX_SVG_SCALE;
    isDisabledZoomOut.value =
      $gmap.value.getZoom() <= Settings.MAP_MIN_SVG_SCALE;
  }
};

const handleGoogleDragEnd = () => {
  closeMapInfoWindow();
  closeAmenityInfoWindow();
  emit('closeLotInfo');
  emit('closeAmenityInfo');
  emit('closeAmenityInfo');
};

const closeMapInfoWindow = () => {
  if (googleInfoWindow.value) {
    googleInfoWindow.value.close();
    googleInfoWindow.value = '';
    if (selectedLotId.value && isTablet) {
      emit('showHeader');
      emit('showSidebar');
      emit('showFooter');
    }
    if (selectedLotId.value && hasMobile) {
      toggleBars();
    }
    selectedLotId.value = '';
  }
};

const closeAmenityInfoWindow = () => {
  if (googleAmenityInfoWindow.value) {
    googleAmenityInfoWindow.value.close();
    googleAmenityInfoWindow.value = '';
    if (amenityId.value && isTablet) {
      emit('showHeader');
      emit('showSidebar');
      emit('showFooter');
    }
    if (amenityId.value && hasMobile) {
      toggleBars();
    }
    amenityId.value = '';
  }
};

const bindLotInfo = async (
  latLng: google.maps.LatLngLiteral,
  lotId: string
) => {
  closeMapInfoWindow();

  if (isTablet) {
    emit('hideFooter');
    emit('hideHeader');
    emit('hideSidebar');
  }

  selectedLotId.value = lotId;
  googleInfoWindow.value = new window.google.maps.InfoWindow();
  googleInfoWindow.value.setPosition(latLng);
  googleInfoWindow.value.open($gmap.value);

  const currentLotNeighborhoodId = lotId.split('-')[0];
  const { result } = await apiFetchLotInfo(
    currentLotNeighborhoodId,
    lotId,
    mode.value
  );

  if (result && result.lot.id === lotId) {
    emit('showPlanFutureLotFlyout', { lotInfo: result, lotId });

    result.neighborhoodName = neighborhoods.value.find(
      (n) => n.neighborhood_code === currentLotNeighborhoodId
    )?.marketing_name;

    const container = document.createElement('div');
    const propsData = {
      lotInfo: result,
      lotId: lotId,
      isKioskMode: isKioskMode.value,
      neighborhoodId: currentLotNeighborhoodId,
      updateLotInfo: (payload: {
        lotInfo: LotInfo | LotDetail;
        lotId: string;
      }) => emit('updateLotInfo', payload),
      mobileOpenContactInfo,
    };

    const instance = createApp(PlatMapLotInfobox, propsData);
    instance.mount(container);

    const el = container.firstElementChild as HTMLElement;
    googleInfoWindow.value.setContent(el);
    googleInfoWindow.value.open($gmap.value);
  }

  const closeElement = document.querySelector('.emb_closeicon');
  closeElement?.addEventListener('click', () => closeMapInfoWindow());
};

const mobileOpenContactInfo = () => {
  emit('calculateContactInfoTopPosition');
  emit('handleVisitClick');
};

const bindAminityInfo = async (
  latLng: google.maps.LatLngLiteral,
  id: string
) => {
  closeAmenityInfoWindow();

  if (isTablet) {
    emit('hideFooter');
    emit('hideHeader');
    emit('hideSidebar');
  }

  amenityId.value = id;
  googleAmenityInfoWindow.value = new window.google.maps.InfoWindow();
  googleAmenityInfoWindow.value.setPosition(latLng);
  googleAmenityInfoWindow.value.open($gmap.value);
  $gmap.value.setCenter(latLng);

  const { result } = await apiFetchAminityInfo(id);
  amenityInfo.value = result;

  if (result && result[0]?.id === id) {
    const container = document.createElement('div');
    const propsData = {
      amenityInfo: result,
      amenityId: id,
      isKioskMode: isKioskMode.value,
      uniqueAmenity: uniqueAmenity.value,
      amenities: amenities.value,
      loadNewAmenity,
    };

    const instance = createApp(PlatMapAminityInfobox, propsData);
    instance.mount(container);

    const el = container.firstElementChild as HTMLElement;
    googleAmenityInfoWindow.value.setContent(el);
    googleAmenityInfoWindow.value.open($gmap.value);
  }

  const closeElement = document.querySelector('.emb_closeicon');
  closeElement?.addEventListener('click', () => closeAmenityInfoWindow());
};

const loadNewAmenity = () => {
  const currentIndex = uniqueAmenity.value.indexOf(amenityId.value);
  const nextIndex = (currentIndex + 1) % uniqueAmenity.value.length;
  const nextAmenityId = uniqueAmenity.value[nextIndex];

  const amenityElement = document.getElementById(nextAmenityId) as HTMLElement;
  if (amenityElement) {
    const rect = amenityElement.getBoundingClientRect();
    const latLng = getLatLong(rect.x, rect.y);
    bindAminityInfo(latLng, nextAmenityId);
  }

  if (hasMobile) {
    toggleBars();
  }
};

__expose({
  ready,
  countLotsFilterPlans,
  svgZoomIn,
  svgZoomOut,
  svgAutoFit,
  setMapCenterUsingPixel,
  getplanAttachedLotsStatus,
  closeMapInfoWindow,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(underlay))
      ? (_openBlock(), _createBlock(_unref(GoogleMap), {
          key: 0,
          style: _normalizeStyle(styleObject),
          "api-promise": _unref(apiPromise),
          zoom: _unref(mapDefaultZoom),
          center: { lat: _unref(centerLat), lng: _unref(centerLong) },
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          options: { minZoom: 10, maxZoom: 20 },
          ref_key: "mapRef",
          ref: mapRef,
          id: "map"
        }, null, 8, ["style", "api-promise", "zoom", "center"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", {
            id: "plan-svg",
            style: { transform: `scale(1,1)` }
          }, null, -1)
        ]))]))
  ]))
}
}

})